export interface ISearchAddress360 {
  unitNumber: string;
  houseNumber: string;
  streetName: string;
  city: string;
  province: string;
  postalCode: string;
}

export class SearchAddress360 implements ISearchAddress360 {
  unitNumber: string;
  houseNumber: string;
  streetName: string;
  city: string;
  province: string;
  postalCode: string;

  constructor(
    address: ISearchAddress360 = {
      unitNumber: '',
      houseNumber: '',
      streetName: '',
      city: '',
      province: '',
      postalCode: '',
    }
  ) {
    const { unitNumber, houseNumber, streetName, city, province, postalCode } =
      address;

    this.unitNumber = unitNumber;
    this.houseNumber = houseNumber;
    this.streetName = streetName;
    this.city = city;
    this.province = province;
    this.postalCode = postalCode;
  }
}
